import m from 'mithril'

export default {
  view: vnode => {
    const sled = require('./sled.jpg')
    const sled2 = require('./sled2.jpg')
    return (      
      <div className={`log-book-page-content-inner log-book-page-template mod-11-page mod-instructions`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
        <figure className="log-book-figure">
            <img src={sled} className="log-book-img" />            
          </figure>
          <figure className="log-book-figure">
            <img src={sled2} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Søren og Kent på slædetur
            </figcaption>
          </figure>
            
        </div>
      </div>
    )
  }
}
